import { useSession, type OrgNode } from '@portal/platform/session';

/**
 * The org node the portal is scoped to, as the tree describes it (name, path, logo), or null
 * before the tree has loaded.
 */
export function useCurrentOrgNode(): OrgNode | null {
  const { orgTree, scope } = useSession();
  const id = scope.current?.id;
  if (!id || !orgTree) {
    return null;
  }
  return (
    orgTree.nodes.find(node => node.id === id) ?? (orgTree.root?.id === id ? orgTree.root : null)
  );
}

/**
 * The names of `node`'s ancestors, root first, as far as the tree knows them. A user's tree starts
 * at their own node, so ancestors above it are skipped rather than shown as ids (CLAUDE.md #4).
 */
export function ancestorNames(node: OrgNode, nodes: readonly OrgNode[]): string[] {
  const byId = new Map(nodes.map(entry => [entry.id, entry.name]));
  return node.orgPath
    .filter(id => id !== node.id)
    .flatMap(id => {
      const name = byId.get(id);
      return name ? [name] : [];
    });
}
